import React from 'react'

const LowerRight = (props) => {
  const { data } = props;
  function capitalizeName(name) {
  if (!name) return '';
  
  return name
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
  const sortedData = sortFacultyByDesignation(data || []);

function sortFacultyByDesignation(data) {
  const designationOrder = [
    "Superintending Surveyor",
    "Deputy Superintending Surveyor",
    "Officer Surveyor",
    "Surveyor"
  ];

  return data.sort((a, b) => {
    const aRank = designationOrder.indexOf(a.designation);
    const bRank = designationOrder.indexOf(b.designation);

    return (aRank === -1 ? Infinity : aRank) - (bRank === -1 ? Infinity : bRank);
  });
}

  return (
<div className="flex justify-center">
  <div className="overflow-x-scroll">
    <table className="table-auto w-full">
      <thead>
        <tr className="bg-blue-500 text-white">
          <th className="px-4 py-2">Name</th>
          <th className="px-4 py-2">Designation</th>
          <th className="px-4 py-2">Position</th>
        </tr>
      </thead>
      <tbody>
        {sortedData?.map((row, index) => (
          <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'}`}>
            <td className="px-4 py-2 whitespace-no-wrap text-left capitalize">{capitalizeName(row.full_name || row.name)}</td>
            <td className="px-4 py-2 whitespace-no-wrap  text-left">{row.designation}</td>
            <td className="px-4 py-2 whitespace-no-wrap">{row.faculty_position}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
  )
}

export default LowerRight